import React from 'react';

// import './App.css';
import './App.scss';
import '@fontsource/montserrat/300.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/700.css';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ConfigurationProvider } from './app/context/configurationContext';

import Layout from './app/layout/layout';
import RouterProtected from './app/router/routerProtected';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './theme';
import { PrestadorProvider } from './app/context/prestadorContext';
import { OnboardingProvider } from './app/context/onboardingContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ThemeProvider theme={theme}>
          <ConfigurationProvider>
            <OnboardingProvider>
              <PrestadorProvider>
                <RouterProtected>
                  <Layout />
                </RouterProtected>
              </PrestadorProvider>
            </OnboardingProvider>
          </ConfigurationProvider>
        </ThemeProvider>
      </LocalizationProvider>
    </QueryClientProvider>
  );
}

export default App;
